module.exports = __webpack_public_path__ + "static/media/scrumThumb.4bc283fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/scrumThumb.png
// module id = 433
// module chunks = 0